import React, { forwardRef } from 'react'

import { Text } from '../Text'
import { InputGroup } from '../InputGroup'
import { InputRightAddon } from '../InputAddon'
import { TextInput, TextInputProps } from '../TextInput'
import { splitStyleProps } from '../../utils'

export interface UnitInputProps extends TextInputProps {
  symbol?: string
}

export const UnitInput = forwardRef(({ symbol = '$', ...restProps }: UnitInputProps, ref) => {
  const [styleProps, inputProps] = splitStyleProps(restProps)

  return (
    <InputGroup w="10rem" {...styleProps}>
      <TextInput ref={ref} {...inputProps} />

      <InputRightAddon bg="gray.50">
        <Text fontFamily="heading" color="blackAlpha.700">
          {symbol}
        </Text>
      </InputRightAddon>
    </InputGroup>
  )
})

UnitInput.displayName = 'UnitInput'

export default UnitInput
